<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <MerchantMultiselect :multiple="true" v-model="merchantsFilter">
                      </MerchantMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"  v-if="isAdmin || isOperator || isMerchant || isMerchantOperator || isReferral">
                  <div class="col p-0">
                    <div class="">
                      <StoreMultiselect :multiple="true" v-model="storesFilter">
                      </StoreMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"  v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                      </TrafficGroupMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" v-if="isAdmin || isOperator || isTeamLead">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect @update:model-value="onTraderListUpdate" :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(DealStatus)"
                                   :custom-label="(opt) => helper.trans(`deal_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.statuses')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="methods"
                                   class="multiselect-sm"
                                   v-model="requestDTO.methods"
                                   :options="store.getters['currencyMethods/methods']()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_methods')"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="types"
                                   class="multiselect-sm"
                                   v-model="requestDTO.types"
                                   :options="Object.values(Direction)"
                                   :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.type')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div  class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" v-if="isAdmin || isOperator || (isTrader && !user.pcId) || isTraderOperator ">
                  <div class="col p-0">
                    <div class="">
                      <DevicesMultiselect ref="deviceMultiselect" :multiple="true" :trader-ids="tradersFilter.map((item) => item.id)" v-model="devicesFilter">
                      </DevicesMultiselect>
                    </div>
                  </div>
                </div>

                <div  class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <TeamLeadMultiselect :multiple="false" v-model="teamLeadFilter"></TeamLeadMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currency"
                                   class="multiselect-sm multiselect-capitalize"
                                   v-model="requestDTO.currency"
                                   :options="store.getters['currencyMethods/currencies']"
                                   :custom-label="(opt) => opt"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currency')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountFrom" class="form-control form-control-sm" :placeholder="helper.trans('labels.from_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountTo" class="form-control form-control-sm" :placeholder="helper.trans('labels.to_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
                  <div class="col p-0">
                    <div class="form-check small mb-0 mt-1">
                      <input class="form-check-input" v-model="requestDTO.onlyProviders" true-value="1" type="checkbox" value="" id="onlyProviders">
                      <label class="form-check-label" for="onlyProviders">
                        {{ helper.trans('labels.only_providers') }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
              <div class="row mt-3" v-if="isAdmin || isOperator || isMerchant || isMerchantOperator || isReferral">
                <div v-if="isAdmin || isOperator || isReferral" class="form-group mb-2 col-auto me-2">
                  <div class="col p-0">
                    <div class="d-flex align-items-center flex-nowrap">
                      <label class="me-2 mb-0">{{helper.trans('labels.group_by')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="store" class="btn-check" name="options-outlined" id="group-stores" autocomplete="off" checked>
                      <label class="btn btn-sm btn-outline-dark" for="group-stores"> {{helper.trans('labels.stores')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="trader" class="btn-check" name="options-outlined" id="group-traders" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="group-traders">{{helper.trans('labels.traders')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="provider" class="btn-check" name="options-outlined" id="group-providers" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="group-providers">{{helper.trans('labels.providers')}}</label>
                    </div>
                  </div>
                </div>

                <div class="col text-end" v-if="reportTypeOptions.length">
                  <div class="dropdown d-inline-block">
                    <button
                      class="btn btn-outline-primary btn-sm rounded-pill text-capitalize-first dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      v-bs-dropdown-fixed
                      aria-expanded="false"
                    >
                      <i class="fa-solid fa-download"></i> {{ helper.trans('labels.download_detailed_report') }}
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li v-for="option in reportTypeOptions" :key="option.value">
                        <a class="dropdown-item text-capitalize-first" href="#" @click.prevent="onReportOptionClick(option)">
                          {{ option.label }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="row" v-if="isAdmin || isOperator">
                <div v-if="isAdmin || isOperator" class="form-group mb-2 col-sm-12 me-2">
                  <div class="col p-0">
                    <div class="">
                      <label class="me-2">{{helper.trans('labels.sort_by')}}</label>
                      <button class="btn btn-sm me-2" :class="{'btn-outline-dark': orderBy.field !== field, 'btn-dark': orderBy.field === field}" @click.prevent="helper.toggleOrderBy(orderBy, field)" v-for="field in orderByFields" :key="field" >
                        {{helper.trans(`labels.${field}`)}} <i class="fa-solid"  :class="helper.orderByClass(orderBy, field)" ></i>
                      </button>

                      <label class="me-2">{{helper.trans('labels.status')}}:</label>
                      <div class="d-inline-block" style="width: 200px;">
                        <Multiselect id="order-by-status"
                                     class="multiselect-sm multiselect-capitalize me-2"
                                     v-model="orderByStatus"
                                     :options="statuses"
                                     :custom-label="(opt) => helper.trans(`deal_status.${opt}`)"
                                     :multiple="false"
                                     select-label="Select"
                                     :placeholder="helper.trans('labels.status')"
                        >
                        </Multiselect>
                      </div>


                      <label class="me-2 ms-2">{{helper.trans('labels.type')}}:</label>
                      <div class="d-inline-block" style="width: 200px;">
                        <Multiselect id="order-by-direction"
                                     class="multiselect-sm multiselect-capitalize"
                                     v-model="orderByType"
                                     :options="Object.values(Direction)"
                                     :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                                     :multiple="false"
                                     select-label="Select"
                                     :placeholder="helper.trans('labels.type')"
                        >
                        </Multiselect>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div>
            <div class="card card-body mb-0">
              <div class="overflow-auto">
                <table  class="table table-bordered align-middle text-left text-nowrap position-relative">
                  <template v-for="group in sortedGroups" :key="group.groupId">
                    <thead>
                    <tr>
                      <th colspan="20" class="text-center bg-secondary text-white">
                        <span v-if="group.groupId === '0'" class="text-center mb-2 text-capitalize">
                          {{ helper.trans('labels.total') }}
                        </span>
                        <span v-if="group.store" class="text-center mb-2">
                          {{ `${group.store?.merchantName} - ${group.store?.name}`}}
                        </span>
                        <span v-if="group.trader" class="text-center mb-2">
                          {{ group.trader?.name }} <span v-if="group.trader?.email.length > 0">({{group.trader?.email}})</span>
                        </span>
                      </th>
                    </tr>
                    </thead>
                    <template v-for="(typeStat, type) in group.byDirections" :key="type">
                      <thead>
                      <tr>
                        <th colspan="20" class="text-center text-capitalize">
                          {{helper.trans(`direction.${type}`)}}
                        </th>
                      </tr>
                      </thead>
                      <thead>
                      <tr class="bg-light">
                        <th rowspan="2" class="text-capitalize-first" style="width: 0;">{{ helper.trans('labels.status') }}</th>
                        <th rowspan="2" class="text-capitalize-first" style="width: 0;">{{ helper.trans('labels.count') }}</th>
                        <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">{{ helper.trans('labels.taker_sum') }}</th>
                        <th v-if="mainFields.includes('traders')" rowspan="2" class="text-capitalize-first text-wrap" style="width: 0">
                          {{ type === Direction.PAY_IN ? helper.trans('labels.trader_sum_out') : helper.trans('labels.trader_sum_in') }}
                        </th>
                        <th v-if="showStoreRate" rowspan="2" class="text-capitalize-first text-wrap" style="width: 0">{{ helper.trans('labels.store_rate_sum') }}</th>
                        <th v-if="mainFields.includes('stores')" rowspan="2" class="text-capitalize-first text-wrap" style="width: 0">
                          {{ type === Direction.PAY_IN ? helper.trans('labels.store_sum_in') : helper.trans('labels.store_sum_out') }}
                        </th>
                        <th v-if="mainFields.includes('fee')" rowspan="2" class="text-capitalize-first text-wrap" style="width: 0">{{ helper.trans('labels.store_fee_sum') }}</th>
                        <th v-if="rewardFields.length > 0" :colspan="rewardFields.length + (rewardFields.includes('service') ? partners.length + (partners.length > 0 ? 1 : 0) : 0)" class="text-center p-0">{{ helper.trans('labels.rewards') }}</th>
                      </tr>
                      <tr class="bg-light">
                        <th class="text-capitalize-first text-center" style="width: 0;" v-if="rewardFields.includes('trader')">{{ helper.trans('labels.trader') }}</th>
                        <th class="text-capitalize-first text-center" style="width: 0;" v-if="rewardFields.includes('teamlead')">{{ helper.trans('labels.teamlead') }}</th>
                        <th class="text-capitalize-first text-center" style="width: 0;" v-if="rewardFields.includes('referral')">{{ helper.trans('labels.referral') }}</th>
                        <th class="text-capitalize-first text-center" style="width: 0;" v-if="rewardFields.includes('service')">{{ helper.trans('labels.service') }}</th>
                        <template v-if="rewardFields.includes('service')">
                          <th v-for="partner in partners" class="text-capitalize-first text-center" style="width: 0;">{{ partner.userName }}</th>
                          <th class="text-capitalize-first text-center" style="width: 0;" v-if="partners.length > 0">{{ helper.trans('labels.rest_of') }}</th>
                        </template>

                      </tr>
                      </thead>
                      <tbody class="text-end">
                      <template v-for="status in statuses" :key="status">
                        <tr v-if="typeStat[status]" :class="{'text-success': status === 'processed', 'text-danger' : status === 'rejected', 'text-secondary': !['processed', 'rejected', 'total', DealStatus.COMPLETED].includes(status), 'small': !['processed', 'rejected', 'total',DealStatus.COMPLETED].includes(status)}">
                          <td class="text-capitalize-first text-start">{{helper.trans(`deal_status.${status}`)}}</td>
                          <td class="text-start">
                            {{ numberFormatter.formatNumber(typeStat[status].count) }}
                            <span v-if="status === 'rejected' || status === 'processed' || status === 'total' || status === ACCEPTED_BY_TRADER_STATUS">
                              ({{numberFormatter.formatNumber(group.countByDirections[type] ? typeStat[status].count/group.countByDirections[type] * 100 : 0, 1) }}%)
                            </span>
                            <span v-else-if="status === 'completed_with_dispute'">
                              ({{numberFormatter.formatNumber((group.byDirections[type]['completed']?.count || 0) > 0 ? typeStat[status].count/(group.byDirections[type]['completed'].count) * 100 : 0, 1) }}%)
                            </span>
                            <span v-else-if="status === 'completed_with_dispute_with_attach'">
                              ({{numberFormatter.formatNumber((group.byDirections[type]['completed']?.count || 0) > 0 ? typeStat[status].count/(group.byDirections[type]['completed'].count) * 100 : 0, 1) }}%)
                            </span>
                            <span v-else>
                              ({{numberFormatter.formatNumber(group.countByDirections[type] ? typeStat[status].count/group.countByDirections[type] * 100 : 0, 1) }}% / {{numberFormatter.formatNumber(group.dealsCountByDirections[type] ? typeStat[status].count/group.dealsCountByDirections[type] * 100 : 0, 1) }}%)
                            </span>
                          </td>
                          <td>
                            <div v-for="(sum, currency) in typeStat[status].takerSums" :key="currency">
                              {{ numberFormatter.formatMoney(sum) }}
                            </div>
                          </td>
                          <td v-if="mainFields.includes('traders')">
                            <div v-for="(sum, currency) in typeStat[status].makerSums" :key="currency">
                              {{ status !== DealStatus.COMPLETED ? '' : type === Direction.PAY_IN ? '-' : '+' }}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                            </div>
                          </td>
                          <td v-if="showStoreRate">
                            <div v-for="(sum, currency) in typeStat[status].merchantMakerSums" :key="currency">
                              {{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                            </div>
                          </td>
                          <td v-if="mainFields.includes('stores')">
                            <div v-for="(sum, currency) in typeStat[status].storeSums" :key="currency">
                              <span>{{ status !== DealStatus.COMPLETED ? '' : type === Direction.PAY_IN ? '+' : '-' }}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}</span>
                            </div>
                          </td>
                          <td v-if="mainFields.includes('fee')">
                            <div v-for="(sum, currency) in typeStat[status].storeFeeSums" :key="currency">
                              {{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small v-if="isAdmin && status === DealStatus.COMPLETED && feeBaseSums(typeStat[status])[currency] && feeBaseSums(typeStat[status])[currency].amount != '0'">
                                ({{numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(feeBaseSums(typeStat[status])[currency].amount) * 100, 1)}}%)
                              </small>
                            </div>
                          </td>
                          <td v-if="rewardFields.includes('trader')">
                            <div v-for="(sum, currency) in typeStat[status].traderRewardSums" :key="currency">
                              {{status !== DealStatus.COMPLETED ? '' : '+'}}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small v-if="isAdmin && status === DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0'">
                                ({{numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)}}%)
                              </small>
                            </div>
                          </td>
                          <td v-if="rewardFields.includes('teamlead')">
                            <div v-for="(sum, currency) in typeStat[status].traderRefRewardSums" :key="currency">
                              {{status !== DealStatus.COMPLETED ? '' : '+'}}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small v-if="isAdmin && status === DealStatus.COMPLETED &&typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0'">
                                ({{numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)}}%)
                              </small>
                            </div>
                          </td>
                          <td v-if="rewardFields.includes('referral')">
                            <div v-for="(sum, currency) in typeStat[status].merchantRefRewardSums" :key="currency">
                              {{status !== DealStatus.COMPLETED ? '' : '+'}}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small v-if="isAdmin && status === DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0'">
                                ({{numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)}}%)
                              </small>
                            </div>
                          </td>
                          <td v-if="rewardFields.includes('service')">
                            <div v-for="(sum, currency) in typeStat[status].serviceRewardSums" :key="currency">
                              {{status !== DealStatus.COMPLETED ? '' : '+'}}{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small v-if="isAdmin && status === DealStatus.COMPLETED && typeStat[status].makerSums[currency] && typeStat[status].makerSums[currency].amount != '0'">
                                ({{numberFormatter.formatNumber(parseFloat(sum.amount)/parseFloat(typeStat[status].makerSums[currency].amount) * 100, 1)}}%)
                              </small>
                              <small v-if="typeStat[status].serviceAdditionalRewardSums[currency]">
                                ({{status !== DealStatus.COMPLETED ? '' : '+'}}{{ numberFormatter.formatMoney(typeStat[status].serviceAdditionalRewardSums[currency], usdtSubunits) }})
                              </small>
                            </div>
                          </td>
                          <template v-if="rewardFields.includes('service')">
                            <td v-for="partner in partners">
                              <div v-for="(sum, currency) in typeStat[status].partnersRewards[partner.userId]" :key="currency">
                                {{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              </div>
                            </td>
                            <td v-if="typeStat[status].partnersRewards[0]">
                              <div v-for="(sum, currency) in typeStat[status].partnersRewards[0]" :key="currency">
                                {{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              </div>
                            </td>
                          </template>
                        </tr>
                      </template>
                      </tbody>
                    </template>
                    <tbody>
                    <tr>
                      <td colspan="20"></td>
                    </tr>
                    </tbody>
                  </template>
                </table>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import {DealStatus} from "@/models/enum/DealStatus";
import {Dictionary} from "@/types";
import MoneyDTO from "@/models/MoneyDTO";
import {Direction} from "@/models/enum/Direction";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import TraderDTO from "@/models/TraderDTO";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import moment from "moment";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import UserDTO from "@/models/UserDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import OrderByDTO from "@/models/OrderByDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import MerchantDTO from "@/models/MerchantDTO";
import ProviderDTO from "@/models/ProviderDTO";
import ConfirmModal from "@/components/ConfirmModal.vue";
import {createExportTask} from "@/service/exportTaskCreate";

const api = new APIClient();
const notification = useNotification()

interface SummaryStat {
  type: string,
  status: string,
  count: number,
  makerSums: Dictionary<MoneyDTO>,
  merchantMakerSums: Dictionary<MoneyDTO>,
  takerSums: Dictionary<MoneyDTO>,
  traderRewardSums: Dictionary<MoneyDTO>,
  traderRefRewardSums: Dictionary<MoneyDTO>,
  merchantRefRewardSums: Dictionary<MoneyDTO>,
  storeSums: Dictionary<MoneyDTO>,
  storeFeeSums: Dictionary<MoneyDTO>,
  serviceRewardSums: Dictionary<MoneyDTO>,
  serviceAdditionalRewardSums: Dictionary<MoneyDTO>,
  partnersRewards: Dictionary<Dictionary<MoneyDTO>>
}

interface GroupSummaryStat {
  groupId: string,
  store: MerchantStoreDTO|null,
  trader: TraderDTO|null,
  provider: ProviderDTO|null,
  byDirections: Dictionary<Dictionary<SummaryStat>>,
  countByDirections: Dictionary<number>,
  dealsCountByDirections: Dictionary<number>,
}

const orderByFields = ['taker_sum', 'count']
const ACCEPTED_BY_TRADER_STATUS = 'accepted_by_trader'
const statuses = ['total', ACCEPTED_BY_TRADER_STATUS, 'processed', 'rejected', DealStatus.COMPLETED, 'completed_with_dispute', 'completed_with_dispute_with_attach', DealStatus.CANCELED, DealStatus.DISPUTE, DealStatus.TRANSFER_WAITING, DealStatus.TRANSFER_CONFIRMED, DealStatus.NEW]

export default defineComponent({
  components: {
    MerchantMultiselect,
    FormInputWrapper,
    PayMethodIcon,
    TeamLeadMultiselect,
    TrafficGroupMultiselect,
    DatePicker,
    Multiselect,
    StoreMultiselect,
    TraderMultiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
    DevicesMultiselect,
    ConfirmModal,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const deviceMultiselect = ref<InstanceType<typeof DevicesMultiselect> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    let defaultGroupBy = 'store';
    if (store.getters.isTrader || store.getters.isTraderOperator || store.getters.isTeamLead) {
      defaultGroupBy = 'trader'
    } else if (store.getters.isReferral || store.getters.isMerchant || store.getters.isMerchantOperator) {
      defaultGroupBy = 'store'
    }

    let mainFields = ['traders', 'stores', 'fee'];
    let rewardFields = ['trader', 'teamlead', 'referral', 'service'];
    if (store.getters.isTrader || store.getters.isTraderOperator) {
      mainFields = ['traders'];
      rewardFields = ['trader']
    } else if (store.getters.isTeamLead) {
      mainFields = ['traders'];
      rewardFields = ['trader', 'teamlead']
    } else if (store.getters.isMerchant || store.getters.isMerchantOperator) {
      mainFields = ['traders', 'stores', 'fee'];
      rewardFields = []
    } else if (store.getters.isReferral) {
      mainFields = ['traders', 'stores', 'fee'];
      rewardFields = ['referral']
    }


    const state = reactive({
      usdtSubunits: 2,
      tradersFilter: [] as TraderDTO[],
      merchantsFilter: [] as MerchantDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      devicesFilter: [] as TraderDeviceDTO[],
      teamLeadFilter: null as UserDTO|null,
      groups: {} as Dictionary<GroupSummaryStat>,
      orderByStatus: 'total' as string,
      orderByType: Direction.PAY_IN as Direction,
      orderBy: {
        field: 'taker_sum',
        direction: 'desc'
      } as OrderByDTO,
      requestDTO: {
        groupBy: defaultGroupBy,
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        currency: null,
        amountFrom: null,
        amountTo: null,
        onlyProviders: null,
      } as any,
      partners: [] as any[]
    });

    const reportTypeOptions = computed(() => {
      const options: Array<{ value: string, label: string, async?: boolean }> = [];
      const labels = {
        merchant: helper.trans('labels.deals_registry_report.merchant'),
        provider: helper.trans('labels.deals_registry_report.provider'),
        general: helper.trans('labels.deals_registry_report.general'),
        merchantSummary: helper.trans('labels.deals_registry_report.merchant_summary'),
      };

      if (store.getters.isAdmin || store.getters.isOperator) {
        options.push(
          { value: 'general', label: labels.general },
          { value: 'merchant_summary', label: labels.merchantSummary, async: true },
          { value: 'merchant', label: labels.merchant },
          { value: 'provider', label: labels.provider }
        );
        return options;
      }

      if (store.getters.isMerchant || store.getters.isMerchantOperator) {
        options.push({ value: 'merchant', label: labels.merchant });
        return options;
      }

      if (store.getters.isProvider) {
        options.push({ value: 'provider', label: labels.provider });
        return options;
      }

      return options;
    });


    const onTraderListUpdate = debounce(() => {
      deviceMultiselect.value?.search('')
    }, 1000);


    const loadPartners =  async () => {
      if (store.getters.isAdmin) {
        state.partners = await api.partners()
      }
    }

    const loadSummary = async () => {
      loader.value?.show()
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
      state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
      state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)
      state.requestDTO.deviceIds = state.devicesFilter.map((value) => value.id)
      state.requestDTO.teamLeadId = state.teamLeadFilter?.id

      try {
        const params: any = {
          ...state.requestDTO,
          fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
          toDate: dateHelper.toUTC(state.requestDTO.toDate),
          amountFrom: state.requestDTO.amountFrom,
          amountTo: state.requestDTO.amountTo,
        };

        if (state.requestDTO.onlyProviders === '1' || state.requestDTO.onlyProviders === true) {
          params.onlyProviders = 1;
        }

        const stats = await api.statisticSummary(params);

        const groups = {} as Dictionary<GroupSummaryStat>
        let groupIds = [];

        const shouldShowAcceptedByTrader =
          !Array.isArray(state.requestDTO.types)
          || state.requestDTO.types.length === 0
          || state.requestDTO.types.includes(Direction.PAY_OUT)

        const emptyAcceptedStat = {
          type: Direction.PAY_OUT,
          status: ACCEPTED_BY_TRADER_STATUS,
          count: 0,
          makerSums: {},
          takerSums: {},
          traderRewardSums: {},
          traderRefRewardSums: {},
          merchantRefRewardSums: {},
          storeSums: {},
          merchantMakerSums: {},
          storeFeeSums: {},
          serviceRewardSums: {},
          serviceAdditionalRewardSums: {},
          partnersRewards: {}
        } as SummaryStat

        const totalGroup = {
          store: null,
          trader: null,
          provider: null,
          groupId: '0',
          byDirections: {
            in: {},
            out: shouldShowAcceptedByTrader
              ? {
                [ACCEPTED_BY_TRADER_STATUS]: emptyAcceptedStat,
              }
              : {},
          },
          countByDirections: {
            in: 0,
            out: 0,
          },
          dealsCountByDirections: {
            in: 0,
            out: 0,
          }
        } as GroupSummaryStat

        for (const item of stats) {
          if (item.status === ACCEPTED_BY_TRADER_STATUS) {
            let targetGroup = totalGroup
            if (item.groupId !== '0') {
              if (!groups[item.groupId]) {
                groupIds.push(item.groupId)
                groups[item.groupId] = {
                  store: null,
                  trader: null,
                  provider: null,
                  groupId: item.groupId,
                  byDirections: {},
                  countByDirections: {},
                  dealsCountByDirections: {}
                } as GroupSummaryStat
              }
              targetGroup = groups[item.groupId]
            }

            if (!targetGroup.byDirections[item.type]) {
              targetGroup.byDirections[item.type] = {}
            }

            if (!targetGroup.byDirections[item.type][item.status]) {
              targetGroup.byDirections[item.type][item.status] = {
                type: item.type,
                status: item.status,
                count: 0,
                makerSums: {},
                takerSums: {},
                traderRewardSums: {},
                traderRefRewardSums: {},
                merchantRefRewardSums: {},
                storeSums: {},
                merchantMakerSums: {},
                storeFeeSums: {},
                serviceRewardSums: {},
                serviceAdditionalRewardSums: {},
                partnersRewards: {}
              } as SummaryStat
            }

            const acceptedStat = targetGroup.byDirections[item.type][item.status]
            acceptedStat.count += item.count
            if (item.takerSum) {
              acceptedStat.takerSums[item.takerSum.currency] = helper.sum(acceptedStat.takerSums[item.takerSum.currency], item.takerSum)
            }
            if (item.makerSum) {
              acceptedStat.makerSums[item.makerSum.currency] = helper.sum(acceptedStat.makerSums[item.makerSum.currency], item.makerSum)
            }
            if (item.traderRewardSum) {
              acceptedStat.traderRewardSums[item.traderRewardSum.currency] = helper.sum(acceptedStat.traderRewardSums[item.traderRewardSum.currency], item.traderRewardSum)
            }
            if (item.traderRefRewardSum) {
              acceptedStat.traderRefRewardSums[item.traderRefRewardSum.currency] = helper.sum(acceptedStat.traderRefRewardSums[item.traderRefRewardSum.currency], item.traderRefRewardSum)
            }
            if (item.merchantRefRewardSum) {
              acceptedStat.merchantRefRewardSums[item.merchantRefRewardSum.currency] = helper.sum(acceptedStat.merchantRefRewardSums[item.merchantRefRewardSum.currency], item.merchantRefRewardSum)
            }
            if (item.merchantMakerSum) {
              acceptedStat.merchantMakerSums[item.merchantMakerSum.currency] = helper.sum(acceptedStat.merchantMakerSums[item.merchantMakerSum.currency], item.merchantMakerSum)
            }
            if (item.storeSum) {
              acceptedStat.storeSums[item.storeSum.currency] = helper.sum(acceptedStat.storeSums[item.storeSum.currency], item.storeSum)
            }
            if (item.storeFeeSum) {
              acceptedStat.storeFeeSums[item.storeFeeSum.currency] = helper.sum(acceptedStat.storeFeeSums[item.storeFeeSum.currency], item.storeFeeSum)
            }
            if (item.serviceRewardSum) {
              acceptedStat.serviceRewardSums[item.serviceRewardSum.currency] = helper.sum(acceptedStat.serviceRewardSums[item.serviceRewardSum.currency], item.serviceRewardSum)
            }
            if (item.serviceAdditionalRewardSum) {
              acceptedStat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency] = helper.sum(acceptedStat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency], item.serviceAdditionalRewardSum)
            }
            continue
          }

          if (!groups[item.groupId]) {
            groupIds.push(item.groupId)
            groups[item.groupId] = {
              store: null,
              trader: null,
              provider: null,
              groupId: item.groupId,
              byDirections: {},
              countByDirections: {},
              dealsCountByDirections: {}
            } as GroupSummaryStat
          }

          if (!groups[item.groupId].byDirections[item.type]) {
            groups[item.groupId].byDirections[item.type] = {}
          }

          if (!groups[item.groupId].countByDirections[item.type]) {
            groups[item.groupId].countByDirections[item.type] = 0
          }

          if (!groups[item.groupId].dealsCountByDirections[item.type]) {
            groups[item.groupId].dealsCountByDirections[item.type] = 0
          }

          if (!groups[item.groupId].byDirections[item.type][item.status]) {
            groups[item.groupId].byDirections[item.type][item.status] = {
              type: item.type,
              status: item.status,
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          if (!groups[item.groupId].byDirections[item.type]['processed']) {
            groups[item.groupId].byDirections[item.type]['processed'] = {
              type: item.type,
              status: 'processed',
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          if (!groups[item.groupId].byDirections[item.type]['total']) {
            groups[item.groupId].byDirections[item.type]['total'] = {
              type: item.type,
              status: 'total',
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          if (!totalGroup.byDirections[item.type][item.status]) {
            totalGroup.byDirections[item.type][item.status] = {
              type: item.type,
              status: item.status,
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          if (!totalGroup.byDirections[item.type]['processed']) {
            totalGroup.byDirections[item.type]['processed'] = {
              type: item.type,
              status: 'processed',
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          if (!totalGroup.byDirections[item.type]['total']) {
            totalGroup.byDirections[item.type]['total'] = {
              type: item.type,
              status: 'total',
              count: 0,
              makerSums: {},
              takerSums: {},
              traderRewardSums: {},
              traderRefRewardSums: {},
              merchantRefRewardSums: {},
              storeSums: {},
              merchantMakerSums: {},
              storeFeeSums: {},
              serviceRewardSums: {},
              serviceAdditionalRewardSums: {},
              partnersRewards: {}
            } as SummaryStat
          }

          let stat = groups[item.groupId].byDirections[item.type][item.status]
          let totalStat = totalGroup.byDirections[item.type][item.status]

          let processedStat = groups[item.groupId].byDirections[item.type]['processed']
          let processedTotalStat = totalGroup.byDirections[item.type]['processed']

          let totalStatusStat = groups[item.groupId].byDirections[item.type]['total']
          let totalStatusTotalStat = totalGroup.byDirections[item.type]['total']

          stat.count += item.count
          totalStat.count += item.count
          if (!['rejected', 'completed_with_dispute', 'completed_with_dispute_with_attach', 'completed_with_dispute_without_attach', 'completed_without_dispute'].includes(item.status)) {
            groups[item.groupId].dealsCountByDirections[item.type] = groups[item.groupId].dealsCountByDirections[item.type] + item.count
            totalGroup.dealsCountByDirections[item.type] = totalGroup.dealsCountByDirections[item.type] + item.count
            processedStat.count += item.count
            processedTotalStat.count += item.count
          }

          if (!['completed_with_dispute', 'completed_with_dispute_with_attach', 'completed_with_dispute_without_attach', 'completed_without_dispute'].includes(item.status)) {
            groups[item.groupId].countByDirections[item.type] = groups[item.groupId].countByDirections[item.type] + item.count
            totalGroup.countByDirections[item.type] = totalGroup.countByDirections[item.type] + item.count
            totalStatusStat.count += item.count
            totalStatusTotalStat.count += item.count
          }

          if (item.takerSum) {
            stat.takerSums[item.takerSum.currency] = helper.sum(stat.takerSums[item.takerSum.currency], item.takerSum);
            totalStat.takerSums[item.takerSum.currency] = helper.sum(totalStat.takerSums[item.takerSum.currency], item.takerSum);

            if (!['rejected', 'completed_with_dispute', 'completed_with_dispute_with_attach', 'completed_with_dispute_without_attach', 'completed_without_dispute'].includes(item.status)) {
              processedStat.takerSums[item.takerSum.currency] = helper.sum(processedStat.takerSums[item.takerSum.currency], item.takerSum);
              processedTotalStat.takerSums[item.takerSum.currency] = helper.sum(processedTotalStat.takerSums[item.takerSum.currency], item.takerSum);
            }

            if (!['completed_with_dispute', 'completed_with_dispute_with_attach', 'completed_with_dispute_without_attach', 'completed_without_dispute'].includes(item.status)) {
              totalStatusStat.takerSums[item.takerSum.currency] = helper.sum(totalStatusStat.takerSums[item.takerSum.currency], item.takerSum);
              totalStatusTotalStat.takerSums[item.takerSum.currency] = helper.sum(totalStatusTotalStat.takerSums[item.takerSum.currency], item.takerSum);
            }
          }
          if (item.makerSum) {
            stat.makerSums[item.makerSum.currency] = helper.sum(stat.makerSums[item.makerSum.currency], item.makerSum);
            totalStat.makerSums[item.makerSum.currency] = helper.sum(totalStat.makerSums[item.makerSum.currency], item.makerSum);
          }
          if (item.merchantMakerSum) {
            stat.merchantMakerSums[item.merchantMakerSum.currency] = helper.sum(stat.merchantMakerSums[item.merchantMakerSum.currency], item.merchantMakerSum);
            totalStat.merchantMakerSums[item.merchantMakerSum.currency] = helper.sum(totalStat.merchantMakerSums[item.merchantMakerSum.currency], item.merchantMakerSum);
          }
          if (item.traderRewardSum) {
            stat.traderRewardSums[item.traderRewardSum.currency] = helper.sum(stat.traderRewardSums[item.traderRewardSum.currency], item.traderRewardSum);
            totalStat.traderRewardSums[item.traderRewardSum.currency] = helper.sum(totalStat.traderRewardSums[item.traderRewardSum.currency], item.traderRewardSum);
          }

          if (item.traderRefRewardSum) {
            stat.traderRefRewardSums[item.traderRefRewardSum.currency] = helper.sum(stat.traderRefRewardSums[item.traderRefRewardSum.currency], item.traderRefRewardSum);
            totalStat.traderRefRewardSums[item.traderRefRewardSum.currency] = helper.sum(totalStat.traderRefRewardSums[item.traderRefRewardSum.currency], item.traderRefRewardSum);
          }

          if (item.merchantRefRewardSum) {
            stat.merchantRefRewardSums[item.merchantRefRewardSum.currency] = helper.sum(stat.merchantRefRewardSums[item.merchantRefRewardSum.currency], item.merchantRefRewardSum);
            totalStat.merchantRefRewardSums[item.merchantRefRewardSum.currency] = helper.sum(totalStat.merchantRefRewardSums[item.merchantRefRewardSum.currency], item.merchantRefRewardSum);
          }

          if (item.storeSum) {
            stat.storeSums[item.storeSum.currency] = helper.sum(stat.storeSums[item.storeSum.currency], item.storeSum);
            totalStat.storeSums[item.storeSum.currency] = helper.sum(totalStat.storeSums[item.storeSum.currency], item.storeSum);
          }

          if (item.storeFeeSum) {
            stat.storeFeeSums[item.storeFeeSum.currency] = helper.sum(stat.storeFeeSums[item.storeFeeSum.currency], item.storeFeeSum);
            totalStat.storeFeeSums[item.storeFeeSum.currency] = helper.sum(totalStat.storeFeeSums[item.storeFeeSum.currency], item.storeFeeSum);
          }

          if (item.serviceRewardSum) {
            stat.serviceRewardSums[item.serviceRewardSum.currency] = helper.sum(stat.serviceRewardSums[item.serviceRewardSum.currency], item.serviceRewardSum);
            totalStat.serviceRewardSums[item.serviceRewardSum.currency] = helper.sum(totalStat.serviceRewardSums[item.serviceRewardSum.currency], item.serviceRewardSum);
          }

          if (item.serviceAdditionalRewardSum) {
            stat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency] = helper.sum(stat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency], item.serviceAdditionalRewardSum);
            totalStat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency] = helper.sum(totalStat.serviceAdditionalRewardSums[item.serviceAdditionalRewardSum.currency], item.serviceAdditionalRewardSum);
          }

          if (item.serviceRewardSum && item.makerSum) {
            if (state.partners.length > 0) {
              if (!stat.partnersRewards[0]) {
                stat.partnersRewards[0] = {}
              }
              if (!stat.partnersRewards[0][item.serviceRewardSum.currency]) {
                stat.partnersRewards[0][item.serviceRewardSum.currency] = stat.serviceRewardSums[item.serviceRewardSum.currency]
              }

              if (!totalStat.partnersRewards[0]) {
                totalStat.partnersRewards[0] = {}
              }

              totalStat.partnersRewards[0][item.serviceRewardSum.currency] = helper.sum(totalStat.partnersRewards[0][item.serviceRewardSum.currency], item.serviceRewardSum)
            }

            for (const partner of state.partners) {
              if (!stat.partnersRewards[partner.userId]) {
                stat.partnersRewards[partner.userId] = {}
              }

              if (!totalStat.partnersRewards[partner.userId]) {
                totalStat.partnersRewards[partner.userId] = {}
              }

              const config = partner.config as any;
              const turnoverShare = parseFloat((item.type === Direction.PAY_IN ? config.turnoverInShare : config.turnoverOutShare) ?? '0')
              const revenueShare = parseFloat(config.revenueShare ?? '0')


              const revenue = helper.mul(stat.serviceRewardSums[item.serviceRewardSum.currency], revenueShare)
              const turnover = helper.mul(stat.makerSums[item.serviceRewardSum.currency], turnoverShare)
              stat.partnersRewards[partner.userId][item.serviceRewardSum.currency] = helper.sum(revenue, turnover)
              stat.partnersRewards[0][item.serviceRewardSum.currency] = helper.sub(stat.partnersRewards[0][item.serviceRewardSum.currency], stat.partnersRewards[partner.userId][item.serviceRewardSum.currency])

              const revenueTotal = helper.mul(totalStat.serviceRewardSums[item.serviceRewardSum.currency], revenueShare)
              const turnoverTotal = helper.mul(totalStat.makerSums[item.serviceRewardSum.currency], turnoverShare)
              totalStat.partnersRewards[partner.userId][item.serviceRewardSum.currency] = helper.sum(revenueTotal, turnoverTotal)
              totalStat.partnersRewards[0][item.serviceRewardSum.currency] = helper.sub(totalStat.partnersRewards[0][item.serviceRewardSum.currency], stat.partnersRewards[partner.userId][item.serviceRewardSum.currency])
            }

          }
        }


        state.groups = groups;

        if (state.requestDTO.groupBy === 'store') {
          const stores = (await api.merchantStores({limit: groupIds.length, offset: 0} as PaginationDTO, {ids: groupIds})).items;
          for (const store of stores) {
            if (!state.groups[store.id.toString()]) {
              continue;
            }

            state.groups[store.id.toString()].store = store;
          }
        } else if (state.requestDTO.groupBy === 'provider') {
          const traders = (await api.traders({limit: groupIds.length, offset: 0} as PaginationDTO, {ids: groupIds})).items;
          for (const trader of traders) {
            if (!state.groups[trader.id.toString()]) {
              continue;
            }

            state.groups[trader.id.toString()].trader = trader;
          }
        } else {
          const traders = (await api.traders({limit: groupIds.length, offset: 0} as PaginationDTO, {ids: groupIds})).items;
          for (const trader of traders) {
            if (!state.groups[trader.id.toString()]) {
              continue;
            }

            state.groups[trader.id.toString()].trader = trader;
          }
        }
        if (store.getters.isTrader) {
          state.groups = {'0': totalGroup}
        } else {
          state.groups['0'] = totalGroup
        }

      } finally {
        loader.value?.hide();
      }
    }

    const clearFilters = async () => {
      state.tradersFilter = [];
      state.storesFilter = [];
      state.merchantsFilter = [];
      state.devicesFilter = [];
      state.trafficGroupsFilter = [];
      state.teamLeadFilter = null;
      state.requestDTO = {
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        groupBy: defaultGroupBy,
        options: [],
        methods: [],
        onlyProviders: null,
      }
    }

    const downloadReport = async (reportType?: string) => {
      const type = reportType ?? reportTypeOptions.value[0]?.value;
      if (!type) {
        return;
      }

      loader.value?.show()
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
      state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
      state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)

      try {
        const data = await api.export('deals_registry', {
          ...state.requestDTO,
          fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
          toDate: dateHelper.toUTC(state.requestDTO.toDate),
          amountFrom: state.requestDTO.amountFrom,
          amountTo: state.requestDTO.amountTo,
          reportType: type,
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', 'report.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loader.value?.hide()
      }
    }

    const MAX_MERCHANT_SUMMARY_RANGE_DAYS = 62;

    const startMerchantSummaryExport = async () => {
      if (state.storesFilter.length !== 1) {
        notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('export_tasks.select_single_store')});
        return;
      }

      if (!state.requestDTO.fromDate || !state.requestDTO.toDate) {
        notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('export_tasks.select_date_range')});
        return;
      }

      const fromDate = moment(state.requestDTO.fromDate);
      const toDate = moment(state.requestDTO.toDate);
      if (toDate.diff(fromDate, 'days', true) > MAX_MERCHANT_SUMMARY_RANGE_DAYS || toDate.isSameOrBefore(fromDate)) {
        notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('export_tasks.date_range_exceeded')});
        return;
      }

      try {
        await createExportTask(store, confirmModal, 'merchant_summary', {
          storeId: state.storesFilter[0].id,
          fromDate: dateHelper.toUTC(state.requestDTO.fromDate)!,
          toDate: dateHelper.toUTC(state.requestDTO.toDate)!,
        });
        notification.notify({type: 'success', title: helper.trans('export_tasks.export_started')});
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('export_tasks.generation_error')});
      }
    }

    const onReportOptionClick = (option: { value: string, label: string, async?: boolean }) => {
      if (option.async) {
        startMerchantSummaryExport();
        return;
      }

      downloadReport(option.value);
    }

    const getOrderByValue = (item: SummaryStat) => {
      if (state.orderBy.field === 'count') {
        return item.count;
      }

      if (state.orderBy.field === 'taker_sum') {
        const sums = Object.values(item.takerSums ?? {})
        let total = 0;
        for (const sum of sums) {
          total += parseFloat(sum.amount ?? 0)
        }
        return total;
      }

      return 0;
    }

    const sortedGroups = computed(() => {
      let data = Object.values(state.groups)

      const status = state.orderByStatus
      const direction = state.orderByType

      return data.sort((a, b) => {
        if (a.groupId === '0') {
          return 1;
        }

        if (b.groupId === '0') {
          return 1;
        }

        const aValue = getOrderByValue((a.byDirections[direction] ?? {})[status] ?? {})
        const bValue =getOrderByValue((b.byDirections[direction] ?? {})[status] ?? {})

        return state.orderBy.direction === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue > bValue ? -1 : 1)
      })
    })

    const showStoreRate = computed(() =>
      (!!store.getters.isAdmin || !!store.getters.isOperator)
      && !!store.getters.getAppData?.STATISTIC_SUMMARY_STORE_RATE_COLUMN_ENABLED
    )

    const feeBaseSums = (stat: SummaryStat): Dictionary<MoneyDTO> => showStoreRate.value ? stat.merchantMakerSums : stat.makerSums

    const applyFilters = async () => {
      loadSummary()
    }

    onMounted(async () => {
      await loadPartners()
      loadSummary()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTrader: computed(() => store.getters.isTrader),
      isTeamLead: computed(() => store.getters.isTeamLead),
      isReferral: computed(() => store.getters.isReferral),
      isMerchant: computed(() => store.getters.isMerchant),
      isMerchantOperator: computed(() => store.getters.isMerchantOperator),
      isTraderOperator: computed(() => store.getters.isTraderOperator),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      downloadReport,
      onReportOptionClick,
      confirmModal,
      UserRole,
      DealStatus,
      Direction,
      applyFilters,
      rewardFields,
      mainFields,
      showStoreRate,
      feeBaseSums,
      store,
      onTraderListUpdate,
      deviceMultiselect,
      orderByFields,
      sortedGroups,
      statuses,
      ACCEPTED_BY_TRADER_STATUS,
      reportTypeOptions
    }
  }
})
</script>
